import type { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { store } from '../store/store';

interface ReduxProviderProps {
  children: ReactNode;
}

/**
 * Redux Provider wrapper component.
 */
export function ReduxProvider({ children }: ReduxProviderProps) {
  return <Provider store={store}>{children}</Provider>;
}
